function copyToClipboard(text: string): Promise<void> {
  return navigator.clipboard.writeText(text)
}

export const clipboardUtils = Object.freeze({
  copyToClipboard,
})
